export const VALID_TENANTS = ['moquyun', 'seven', 'nifulei'] as const;

export type TenantCode = typeof VALID_TENANTS[number];

export const isValidTenant = (code: string): code is TenantCode => {
    return VALID_TENANTS.includes(code as TenantCode);
};
